import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "dich_vu_chat_luong_cao";

moduleApi.create = (dataForm) => { 
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.findByIdAllField = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id, fields:"id,an_dich_vu,da_duyet,ly_do_khong_duyet,ten,noi_dung,anh,ghim,thu_tu,tham_chieu_id,thoi_diem_tao,dia_diem"}
  };
  return ApiService(api);
};

export default moduleApi;
